import {createElement, Component, PropTypes} from 'rlink-react';
import RoutingTransitions from 'rlink-router/RoutingTransitions.jsx';
import DocumentTitle from 'rlink-react-document/DocumentTitle.jsx';



const OWN_PROPS = new Set(['title', 'navStateStore', 'head']);

export default class RoutingComponent extends Component {



  viewContent () {
    return this.props.children;
  }

  pathForContent (path) {
    return this.props.pathForContent(path);
  }


  viewContainerProps () {
    return this._passThroughProps(this.props);
  }

  _passThroughProps (inProps) {
    let outProps = {};
    for (let name in inProps) {
      if ( !OWN_PROPS.has(name) ) {
        outProps[name] = inProps[name];
      }
    }
    return outProps;
  }

  viewContainer () {
    return <RoutingTransitions>
      {this.viewContent()}
    </RoutingTransitions>;
  }

  render () {
    return (<div {...this.viewContainerProps()}>
      <DocumentTitle title={this.props.title} />
      {this.viewContainer()}
    </div>);
  }
}

export {default as NavLink} from 'rlink-router/NavLink.jsx';



// WEBPACK FOOTER //
// ./lib/rlink-router/component.jsx